/* eslint-disable no-console */

export default {
  name: 'app',
  components: {
    // Content,
  },

  data() {
    return {
    }
  },

  computed: {
  },

  methods: {
  },

  mounted() {
  }
}